<template>
  <StLottie
    v-if="isShownAnimation"
    :class="{ big: isBig }"
    class="lottie-claim-animation"
    :animation-data="isBig ? confettiBig : confettiSmall"
    @complete="isShownAnimation = false"
  />
</template>

<script setup lang="ts">
import { delay } from '@st/utils'
import confettiSmall from './animations/confettiSmall.json'
import confettiBig from './animations/confettiBig.json'

const { isDelay, isBig } = defineProps<{
  /**
   * нужна для того чтобы при загрузке страницы отрисовались все элементы
   */
  isDelay?: boolean
  /**
   * пропс, а не usePlatform по тому что иногда на деске нужна маленькая анимация
   */
  isBig?: boolean
}>()

const isShownAnimation = ref(false)

async function runClaimAnimation(): Promise<void> {
  if (isDelay) await delay(1000)
  isShownAnimation.value = true
  await until(isShownAnimation.value).toBe(false)
}

defineExpose({
  runClaimAnimation,
})
</script>

<style scoped>
.lottie-claim-animation {
  pointer-events: none;

  position: fixed;
  z-index: 20;
  top: 120px;
  left: 0;

  overflow: visible;

  width: 100%;
  height: 100%;

  background-size: cover;
}

.big {
  top: 105px;
}
</style>
